var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container bg-white",attrs:{"id":"pembaruan"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-18"},[_c('h3',[_vm._v(_vm._s(_vm.$t('tos.pembaruan.title')))]),_c('div',{staticClass:"divider"}),_c('p',[_vm._v(_vm._s(_vm.$t('tos.pembaruan.line1')))])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }